@app.service 'ssoService', ($http, $q, localStorageService, $location)->

  @isZendesk = ->
    rt = $location.search().return_to
    rt? && (rt.indexOf('zendesk') != -1 || rt.indexOf('support.chefsteps.com') != -1)

  @isAmazon = ->
    rt = $location.search().path
    rt? && (rt.indexOf('amazon') != -1 || rt.indexOf('pitangui.amazon.com') != -1)

  @signAndRedirect = (state) ->
    deferred = $q.defer()
    userToken = localStorageService.get('user.token')

    config =
      params:
        # Shopify and Alexa use 'path', zendesk 'return_to'
        path: $location.search().path || $location.search().return_to
        state: state
      headers: { 'Authorization': 'Bearer ' + userToken }

    $http.get("#{csConfig.chefstepsEndpoint}/api/v0/auth/external_redirect", config).then ((response) ->
      deferred.resolve()
      window.location = response.data.redirect

    ), (error) ->
      deferred.reject('There was an error while processing your request.')

    deferred.promise
  this
